import { render } from "./MainDashboard.vue?vue&type=template&id=185eea56&scoped=true"
import script from "./MainDashboard.vue?vue&type=script&lang=js"
export * from "./MainDashboard.vue?vue&type=script&lang=js"

import "./MainDashboard.vue?vue&type=style&index=0&id=185eea56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185eea56"]])

export default __exports__